import React from "react";
import {
  Box,
  Link,
  useDisclosure,
  useMediaQuery,
  Flex,
} from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";
import { Link as ReactRouterLink } from "react-router-dom";
import { DESCRIPTION_ROUTE, FAQ_ROUTE, T_C_ROUTE } from "../../routes";
import SendNote from "../SendNote/SendNote";
import { useLocation } from "react-router-dom";

const portalColor = "#f1f1f1";

const Footer = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isMobile] = useMediaQuery("(max-width: 465px)");
  // this to make عن on top of sal125 on mobile devices per client request
  const aboutSalArabicText = isMobile ? "SAL125 عن" : "SAL125 عن";
  const orderSalMagic = isMobile ? "SAL Magic لطلب" : "SAL Magic لطلب";
  const { locale } = useIntl();
  const location = useLocation();
  return (
    <Box
      as="footer"
      dir="ltr"
      padding={{ base: "30px 10px 10px 10px", md: "60px 20px 10px 20px" }}
      textAlign="center"
      fontSize="13px"
    >
      {window.location.pathname !== "/login" && (
        <Flex
          w="100%"
          flexWrap="wrap"
          alignItems="center"
          justifyContent="center"
          mb="10"
          gap={{ base: 2, md: 4 }}
        >
          <Link
            as="button"
            onClick={() => {
              onOpen();
            }}
            color={location.pathname === "/portal" ? portalColor : "brand.900"}
            textStyle="smallBold"
            px={{ base: 2, md: 5 }}
          >
            <FormattedMessage id="feedback" />
          </Link>
          <Link
            as={ReactRouterLink}
            to={T_C_ROUTE}
            color={location.pathname === "/portal" ? portalColor : "brand.900"}
            textStyle="smallBold"
            px={{ base: 2, md: 5 }}
          >
            <FormattedMessage id="t&c" />
          </Link>
          <Link
            as={ReactRouterLink}
            to={FAQ_ROUTE}
            color={location.pathname === "/portal" ? portalColor : "brand.900"}
            textStyle="smallBold"
            px={{ base: 2, md: 5 }}
          >
            <FormattedMessage id="faq" />
          </Link>
          <Link
            as={ReactRouterLink}
            to={DESCRIPTION_ROUTE}
            color={location.pathname === "/portal" ? portalColor : "brand.900"}
            textStyle="smallBold"
            px={{ base: 2, md: 5 }}
          >
            {locale === "ar" ? aboutSalArabicText : "About SAL125"}
          </Link>
          <Link
            target={"_blank"}
            href={"https://t.me/SmartsWay125"}
            color={location.pathname === "/portal" ? portalColor : "brand.900"}
            textStyle="smallBold"
            px={{ base: 2, md: 5 }}
          >
            <FormattedMessage id="contactSupport" />
          </Link>

          <Link
            target={"_blank"}
            href={
              "https://shop.smartsway.com/index.php?route=product/product&path=63_105&product_id=785"
            }
            color={location.pathname === "/portal" ? portalColor : "brand.900"}
            textStyle="smallBold"
            px={{ base: 2, md: 5 }}
          >
            {locale === "ar" ? orderSalMagic : "Order SAL Magic"}
          </Link>
        </Flex>
      )}
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="center"
        align="center"
        gap={2}
      >
        <strong
          style={{
            color: location.pathname === "/portal" ? portalColor : null,
          }}
        >
          &copy; All Rights Reserved for SmartsWay
        </strong>
        <a
          style={{
            color: location.pathname === "/portal" ? portalColor : null,
          }}
          href="https://techhive.dev/"
        >
          <strong>Developed by Tech Hive Dev</strong>
        </a>
      </Flex>
      <SendNote isOpen={isOpen} onClose={onClose} />
    </Box>
  );
};

export default Footer;
